import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import { Form } from '../../components/forms/Form';
import { TextField } from '../../components/forms/TextField';
import ButtonWithLoading from '../../components/forms/SubmitButton';
import { useCreateForm } from '../../components/forms/hooks/useCreateForm';
import { useAgentTools } from './hooks/useAgentTools';
import { Autocomplete } from '../../components/forms/Autocomplete';
import { AgentToolsField } from './components/AgentToolsField';
import { useAvailableModels } from './hooks/useAvailableModels';

const introHint = "An AI agent chats with your team and can call CRM tools on their behalf. " +
  "Describe its role in the system prompt, grant only the tools it needs, and keep it in Draft " +
  "while you test in chat.";
const systemPromptHint = "Define the agent's role, tone, and rules — e.g. 'You help managers draft " +
  "outreach emails to bloggers. Be concise and never send without approval.'";
const modelHint = "Gemini model powering the agent. It can be changed later.";
const toolsHint = "CRM actions the agent may use — grant the minimum needed. Tools marked ⚠ pause " +
  "for human approval on each call.";

export default function CreateAiAgentPage() {
  const {isSubmitLoading, create, validate} = useCreateForm('aiagents', '/aiagents');
  const tools = useAgentTools();
  const models = useAvailableModels();

  return (<Formik
      initialValues={{
        name: '',
        model: '',
        systemPrompt: '',
        tools: [] as string[],
      }}
      onSubmit={create}
      validate={validate}
    >
      <Form>
        <h2>Create a new AI Agent:</h2>
        <Typography variant="body2" color="text.secondary">{introHint}</Typography>
        <TextField required name="name" label="name"/>
        <TextField name="systemPrompt" label="system prompt" multiline minRows={4} helperText={systemPromptHint}/>
        <Autocomplete required name="model" label="model" options={models?.availableModels ?? []} helperText={modelHint}/>
        <AgentToolsField tools={tools} helperText={toolsHint}/>

        <ButtonWithLoading loading={isSubmitLoading}/>
      </Form>
    </Formik>
  );
}
